import { buriedPoint } from '@pro/common/bury-point';

const bury = {
  loginDialog(type, typeEvent) {
    const op = {
      1: '登录访问',
      2: 'HPC登录访问',
      3: '使用功能',
      4: '忘记密码',
      5: '已升级Onehikid登录失败'
    };
    const opEvent = {
      1: '新首页右上角登录',
      2: '注册弹窗-已有账号登录',
      3: '登录超时',
      4: 'demo顶部提示栏-登录',
      5: '新首页页面中间HPC登录按钮'
    };
    buriedPoint('event', {
      eventCategory: 'Login弹窗',
      action: `Login弹窗-${op[type]}`,
      eventLabel: opEvent[typeEvent] || null
    });
  },
  login() {
    buriedPoint('event', {
      action: 'Login-使用功能',
      eventCategory: 'Login'
    });
  },
  // 登录接口耗时埋点
  loginTimeCounting(value, type) {
    const op = {
      1: 'HPC',
      2: 'SSO'
    };
    buriedPoint('timing', {
      action: '登录耗时-登录接口耗时',
      value,
      eventCategory: '登录耗时',
      eventLabel: op[type]
    });
  },
  resendModelShow() {
    buriedPoint('event', {
      action: 'admin用户注册-未激活账号登录',
      eventCategory: 'admin用户注册'
    });
  },
  resendActiveEmail() {
    buriedPoint('event', {
      action: 'admin用户注册-重新发送激活邮件',
      eventCategory: 'admin用户注册'
    });
  },
  registerDialog(type, typeEvent) {
    // [事件操作，...事件标签]
    const USER = localStorage.getItem('chooseType') ? '-终端用户' : '-服务商';
    const op = {
      1: [
        '注册访问-验证邮箱',
        '新首页右上角',
        '登录弹窗-没有账号？立即注册',
        'demo顶部提示栏-注册',
        '页面底部快速链接-注册'
      ],
      2: ['发送验证码'],
      3: ['重新获取验证码'],
      4: ['未收到验证码'],
      5: ['验证邮箱', `正确${USER}`, `错误${USER}`],
      6: ['注册访问', `认证码必填${USER}`, `认证码选填${USER}`, `不需要验证码${USER}`],
      7: ['完成注册', `认证码必填${USER}`, `认证码选填${USER}`, `不需要验证码${USER}`],
      8: [
        '注册结果',
        `注册成功${USER}`,
        `注册失败，邮箱已存在${USER}`,
        `注册失败，邮件验证码错误${USER}`,
        `注册失败，邮件验证码过期${USER}`,
        `注册失败，邮件验证码尝试超过最大次数${USER}`,
        `B账户池已空${USER}`,
        `IP代表国家与认证码代表国家不一致${USER}`,
        `其他${USER}`
      ],
      9: ['营销活动订阅']
    };

    buriedPoint('event', {
      eventCategory: 'admin注册弹窗（HPC注册）',
      action: `${op[type][0]}`,
      eventLabel: op[type][typeEvent] || null
    });
  },
  statisticsRegistrationRate(type, step, code) {
    const op1 = {
      1: 'oneHikId注册',
      2: 'hpc注册'
    };
    const op2 = {
      1: '获取邮箱验证码',
      2: '校验邮箱验证码',
      3: '校验OneHikID登录token',
      4: '补充公司信息'
    };
    buriedPoint('event', {
      action: `统计注册成功率-${op1[type]}`,
      eventCategory: '统计注册成功率',
      eventLabel: code ? `${op2[step]}-请求失败-${code}` : `${op2[step]}-请求成功`
    });
  },
  identityPageShow() {
    buriedPoint('event', {
      action: '出现弹窗',
      eventCategory: 'admin注册弹窗（HPC注册）'
    });
  },
  identityPageChoose(type) {
    const op = {
      1: '服务供应商',
      2: '终端用户'
    };
    buriedPoint('event', {
      action: '选择',
      eventCategory: 'admin注册弹窗（HPC注册）',
      eventLabel: op[type]
    });
  },
  OHIToOnehikid() {
    buriedPoint('event', {
      action: 'admin注册（OneHikID注册）-1.0进入OneHikID注册页',
      eventCategory: 'admin注册（OneHikID注册）'
    });
  },
  registerClick(type) {
    // [事件操作，...事件标签]
    const op = {
      1: '新首页右上角-注册',
      2: '登录弹窗-没有账号？立即注册',
      3: 'demo顶部提示栏-注册',
      4: '页面底部快速链接-注册'
    };

    buriedPoint('event', {
      eventCategory: 'admin注册弹窗（HPC注册）',
      action: `点击注册`,
      eventLabel: op[type] || null
    });
  },
  loginEvent(type, typeEvent) {
    const op = {
      1: '登录访问',
      2: '了解更多',
      3: '立即试用',
      4: '体验Demo',
      5: '登录',
      6: '注册'
    };
    const opEvent = {
      1: '已填写有效邮箱',
      2: '填写无效邮箱',
      3: '未填写邮箱'
    };
    buriedPoint('event', {
      eventCategory: '新登录页',
      action: `新登录页-${op[type]}`,
      eventLabel: opEvent[typeEvent] || null
    });
  },
  oneHikIDLogin(type, typeEvent) {
    const op = {
      1: 'OneHikID登录',
      2: 'OneHikID登录成功',
      3: 'HPC登录结果'
    };
    const opEvent = {
      1: {
        1: '新首页页面中间OneHikId登录按钮',
        2: '右上角登录下拉选项',
        3: 'HPC登录弹窗底部-“Onehikid登录”'
      },
      3: {
        1: '成功',
        2: '失败'
      }
    };
    buriedPoint('event', {
      eventCategory: 'OneHikID登录',
      action: `OneHikID登录-${op[type]}`,
      eventLabel: (opEvent[type] && opEvent[type][typeEvent]) || null
    });
  },
  getEmailJumpToHomePage() {
    buriedPoint('event', {
      action: '点击邮件链接-跳转进入首页',
      eventCategory: '点击邮件链接'
    });
  },
  bottomIconLink(type) {
    const op = {
      1: 'Device compatibility list',
      2: 'user manual',
      3: 'dateSheet',
      4: "what's new"
    };

    buriedPoint('event', {
      eventCategory: 'bottomIconLink',
      action: 'bottomIconLink',
      eventLabel: op[type]
    });
  },
  bottomWordLink(type) {
    const op = {
      1: 'where to buy',
      2: 'HikVision website',
      3: 'Technology partner portal',
      4: 'eLearning',
      5: 'Privacy policy',
      6: 'Terms of use',
      7: 'B2B2 Terms and Condition',
      8: 'FAQ'
    };

    buriedPoint('event', {
      eventCategory: 'bottomWordLink',
      action: 'bottomWordLink',
      eventLabel: op[type]
    });
  }
};

export default bury;
